// extracted by mini-css-extract-plugin
export default {"item":"item__dufvV","image":"image__NRM1x","img":"img__m4o7c","label":"label__SEika"};